module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row justify-content-center animated fadeInRight"
  }, [_c('div', {
    staticClass: "col-lg-6 col-md-8 col-sm-12"
  }, [_c('div', {
    staticClass: "card-group mb-0"
  }, [_c('div', {
    staticClass: "card p-4"
  }, [_c('div', {
    staticClass: "card-block"
  }, [_c('h1', [_vm._v("Проверьте почту")]), _vm._v(" "), _c('div', {
    staticClass: "alert alert-success"
  }, [_vm._v("\n                        На ваш адрес электронной почты был выслана ссылка для сброса пароля. Пожалуйста откройте письмо и перейдите по ней.\n                        Если письма нет, проверьте папку \"спам\". В ином случае обратитесь к администратору.\n                    ")]), _vm._v(" "), _c('router-link', {
    staticClass: "btn btn-primary",
    attrs: {
      "to": {
        name: 'Auth'
      }
    }
  }, [_vm._v("Вернуться к странице авторизации")])], 1)])])])])
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-1dd200fc", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// /home/alarmplan/staging/shared/frontend/~/vue-loader/lib/template-compiler?{"id":"data-v-1dd200fc"}!/home/alarmplan/staging/shared/frontend/~/vue-loader/lib/selector.js?type=template&index=0!./src/views/Auth/EmailLinkSend.vue
// module id = 1007
// module chunks = 1